/* eslint-disable */
import React from "react"
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import { useState } from 'react'

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch'
      }
    },
    boton: {
    },
    inputRoot: {
      fontSize: 70
    },
    labelRoot: {
      fontSize: 50,
      color: "green",
      "&$labelFocused": {
        color: "purple"
      }
    },
    labelFocused: {}
  }))
  
  export default function MenuDeMuestrasIngresoCDP (props) {
    const classes = useStyles()
    const [muestraIngresoCDP, setmuestraIngresoCDP] = useState('')
    const handleChange = (muestraIngresoCDP) => {
      if (/^(000)?\d{0,12}$/.test(muestraIngresoCDP.target.value)) { 
        setmuestraIngresoCDP(muestraIngresoCDP.target.value)
        
        props.setNumeroDeMuestraCDP(muestraIngresoCDP.target.value)
      } 
    }
    const handleKeyPress = (muestraIngresoCDP) => {
      if (muestraIngresoCDP.key==="Enter"){
        if (/^(000)?\d{0,12}$/.test(muestraIngresoCDP.target.value)) {
          props.setDatos(muestraIngresoCDP.target.value)
          setmuestraIngresoCDP('')
        }
    }}
    
    return (
      <TextField
        InputProps={{ classes: { root: classes.inputRoot } }}
        InputLabelProps={{
          classes: {
            root: classes.labelRoot,
            focused: classes.labelFocused
          }
        }}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        value={muestraIngresoCDP}
        id='outlined-basic'
        label='Número de Carta de Porte'
        variant='outlined'
      />
    )
  }
  